import { render, staticRenderFns } from "./courtInstallationModel.vue?vue&type=template&id=ce5fdefa&scoped=true&"
import script from "./courtInstallationModel.vue?vue&type=script&lang=ts&"
export * from "./courtInstallationModel.vue?vue&type=script&lang=ts&"
import style0 from "./courtInstallationModel.vue?vue&type=style&index=0&id=ce5fdefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5fdefa",
  null
  
)

component.options.__file = "courtInstallationModel.vue"
export default component.exports